import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { QuestionProps } from "../../../typings/register";
import { getQuestionById } from "../../../services/questionService";
import QuestionUpdateHeader from "./QuestionUpdateHeader";
import EditTagQuestion from "../../../components/EditTagQuestion";
import { AnswerdQuestionsProps } from "../../../typings/member";
import { updateQuestionAnswers } from "../../../services/memberService";
import { useHistory } from "react-router-dom";
import EditTagsQuestion from "../../../components/EditTagsQuestion";
import Loader from "react-loader-spinner";
import { QuestionIds } from "../../../helpers/Enums";
import InterestQuestion from "../../../components/InterestQuestion";

export interface UpdateQuestionTagProps {
  questionId: number;
}

const UpdateQuestionTag = (props: any) => {
  const questionId = props.match.params.id;
  const [isLoading, setIsLoading] = useState<boolean>();
  const [question, setQuestion] = useState<QuestionProps>();
  const { memberCode: myMemberCode } = useSelector(
    (state: RootState) => state.member
  );
  let history = useHistory();

  useEffect(() => {
    getQuestion();
  }, []);

  const getQuestion = async () => {
    const { data } = await getQuestionById(myMemberCode, questionId);
    setQuestion(data);
  };

  const onSave = async (tags: number[]) => {
    //make call to save answerdQuestion
    if (question) {
      const sentData: AnswerdQuestionsProps = {
        questionId: question.questionId,
        tags,
      };
      await updateQuestionAnswers(myMemberCode, sentData);
      history.goBack();
    }
  };

  useEffect(() => {
    console.log({ question });
  }, [question]);

  return (
    <>
      <QuestionUpdateHeader />
      {question && question.tags ? (
        <>
          {question.questionId === QuestionIds.INTEREST_QUESTION ? (
            <InterestQuestion question={question} hasNext={null} next={null} />
          ) : question.maxAnswer === 1 ? (
            <EditTagQuestion
              title={question.question}
              subtitle={question.questionSubTitle}
              buttonText={"שמור"}
              tags={question.tags}
              onSave={onSave}
              selectedTagValue={
                question.tags.filter((x) => x.isSelected).map((x) => x.value)[0]
              }
              skipButtonLink={question.skipButtonLink}
            />
          ) : (
            <EditTagsQuestion
              title={question.question}
              questionMaxAsnwer={question.maxAnswer}
              questionMinAsnwer={question.minAnswer}
              subtitle={question.questionSubTitle}
              buttonText={"שמור"}
              tags={question.tags}
              onSave={onSave}
              selectedTagsValue={question.tags
                .filter((x) => x.isSelected)
                .map((x) => x.value)}
              skipButtonLink={question.skipButtonLink}
            />
          )}
        </>
      ) : (
        <div
          style={{
            height: "80vh",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#f47373" height={60} width={60} />
        </div>
      )}
    </>
  );
};

export default UpdateQuestionTag;
